const hideDrawerPrescriptionUpload = () => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  drawer.querySelectorAll('input[type="file"]').forEach((input) => {
    let wrapper = input.parentElement;

    while (wrapper && wrapper.parentElement !== drawer) {
      const text = wrapper.textContent.toLowerCase();
      if (text.includes('upload prescription') || text.includes('drag & drop')) {
        wrapper.hidden = true;
        wrapper.setAttribute('data-drawer-prescription-upload', 'hidden');
        return;
      }
      wrapper = wrapper.parentElement;
    }
  });

  drawer.querySelectorAll('div, section').forEach((element) => {
    const text = element.textContent.trim().toLowerCase();
    if (
      text.length < 250 &&
      (text.includes('upload prescription') || text.includes('drag & drop your files'))
    ) {
      element.hidden = true;
      element.setAttribute('data-drawer-prescription-upload', 'hidden');
    }
  });
};

hideDrawerPrescriptionUpload();

const cartDrawer = document.getElementById('CartDrawer');
if (cartDrawer) {
  let scanScheduled = false;
  new MutationObserver(() => {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(() => {
      scanScheduled = false;
      hideDrawerPrescriptionUpload();
    });
  }).observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}
